import { CloudWatchClient, GetDashboardCommand } from '@aws-sdk/client-cloudwatch';
import { ENVIRONMENT_VARIABLES } from 'src/constants/EnvironmentConstants';
import { CognitoService } from './CognitoService';

const DEFAULT_REGION = ENVIRONMENT_VARIABLES.env.Region || 'us-west-2';
let _defaultClient: CloudWatchClient | null = null;
const _regionClients = new Map<string, CloudWatchClient>();

/**
 * Returns a cached CloudWatch client for the given region.
 * Defaults to the application's configured region (us-west-2).
 */
export const getCloudWatchClient = (region?: string): CloudWatchClient => {
  const targetRegion = region || DEFAULT_REGION;
  if (targetRegion === DEFAULT_REGION) {
    if (!_defaultClient) {
      _defaultClient = new CloudWatchClient({
        region: targetRegion,
        credentials: CognitoService.credentialProvider
      });
    }
    return _defaultClient;
  }
  if (!_regionClients.has(targetRegion)) {
    _regionClients.set(
      targetRegion,
      new CloudWatchClient({
        region: targetRegion,
        credentials: CognitoService.credentialProvider
      })
    );
  }
  return _regionClients.get(targetRegion)!;
};

/**
 * Fetches a CloudWatch dashboard definition and returns the parsed JSON body.
 */
export const fetchDashboardDefinition = async (dashboardName: string): Promise<Record<string, unknown>> => {
  const client = getCloudWatchClient();
  const response = await client.send(new GetDashboardCommand({ DashboardName: dashboardName }));
  if (!response.DashboardBody) {
    throw new Error(`Dashboard ${dashboardName} has no body`);
  }
  return JSON.parse(response.DashboardBody);
};
